


























import { Vue, Component, State, namespace } from 'nuxt-property-decorator'

const experience = namespace('experience')

@Component
export default class SearchTravelServices extends Vue {
  @State klook!: Data.Klook
  @State(state => state.klook.platform) platform!: Data.Klook
  @experience.State travelServices!: any

  spm(data: any) {
    return `Category?trg=manual&oid=category_${data.id}`
  }

  getIcon(service: any) {
    return service?.icon
  }
}
